import React, {memo, useRef} from 'react';
import PropTypes from 'prop-types';
import {BlocksControls, InlineGroup} from 'react-tinacms-inline';
import {usePage} from '../../contexts/PageContext';
import {useBlockProps} from '../../hooks/useBlockProps';
import {PageContainer} from '../Common/PageContainer';
import {GroupContainer} from '../Common/GroupContainer';
import {pageContentBox} from '../../constants/fields/fields';


const PageBlock = ({index, data, children}) => {
  const inputEl = useRef(null);
  const {blockProps} = useBlockProps(data);
  const {showData} = usePage();

  return (
    <BlocksControls index={index} focusRing={{offset: 0}} insetControls>
      <div ref={inputEl}>
        <PageContainer {...blockProps}>
          <GroupContainer {...data?.content} viewport={blockProps.viewport}
            className={`shadow-${blockProps?.content?.shadow} wrapper-container`}>
            <InlineGroup name={'content'} fields={pageContentBox}>
              <div className={'dlf-page-content-group'}>
                {children}
              </div>
            </InlineGroup>
          </GroupContainer>
          {showData && <pre>{JSON.stringify(data, null, 2)}</pre>}
        </PageContainer>
      </div>
    </BlocksControls>

  );
};
export default memo(PageBlock);

PageBlock.propTypes = {
  children: PropTypes.any,
  data: PropTypes.object,
  index: PropTypes.number
};
